var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 8,
  height: 16,
  viewBox: "0 0 8 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Polygon_50",
  "data-name": "Polygon 50",
  transform: "translate(8) rotate(90)",
  fill: "#28af21"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 14.7928991317749 7.5 L 1.207099556922913 7.5 L 7.999999523162842 0.707099974155426 L 14.7928991317749 7.5 Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 7.999999523162842 1.414219856262207 L 2.414219856262207 7 L 13.58577919006348 7 L 7.999999523162842 1.414219856262207 M 7.999999523162842 0 L 16 8 L -9.5367431640625e-07 8 L 7.999999523162842 0 Z",
  stroke: "none",
  fill: "#212121"
}))));
export default __webpack_public_path__ + "static/media/greenContinueIcan.03fd4670.svg";
export { SvgComponent as ReactComponent };